import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Calendar, MapPin } from 'lucide-react';
import "../css/dashboard/chart.css";

const AdminStatsChart1 = ({ doc = [], ec = [], nl = [] }) => {
    const chartData = useMemo(() => {
    const combined = [...doc, ...ec, ...nl];
    
    const counts = combined.reduce((acc, item) => {
        // 1. Normalize to lowercase and trim spaces to ensure accurate grouping
        const office = item.register_office 
            ? item.register_office.toLowerCase().trim() 
            : 'general/other';
            
        acc[office] = (acc[office] || 0) + 1;
        return acc;
    }, {});

    return Object.keys(counts)
        .map(name => ({ 
            // 2. Convert the lowercase key to UPPERCASE for the chart legend
            name: name.toUpperCase(), 
            value: counts[name] 
        }))
        // 3. Keep the sorting so the biggest offices show first
        .sort((a, b) => b.value - a.value);
}, [doc, ec, nl]);

    const totalFiles = chartData.reduce((sum, item) => sum + item.value, 0);
    const COLORS = ['#6366f1', '#10b981', '#f59e0b', '#06b6d4', '#ec4899'];

    return (
        <div className="admin-chart-card">
            <div className="chart-header">
                <div className="title-area">
                    <div className="title-with-icon">
                        <MapPin size={18} style={{ color: '#6366f1' }} />
                        <h3 className="chart-title">Workload by Register Office</h3>
                    </div>
                    <span className="time-badge">
                        <Calendar size={12} /> Total Records: {totalFiles}
                    </span>
                </div>
            </div>

            <div className="chart-wrapper" style={{ position: 'relative', height: '350px' }}>
                <div style={{
                    position: 'absolute',
                    top: '44%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    pointerEvents: 'none'
                }}>
                    <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b' }}>{totalFiles}</span>
                    <p style={{ fontSize: '12px', color: '#64748b', margin: 0 }}>Count</p>
                </div>

                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={80}
                            outerRadius={105}
                            paddingAngle={5}
                            dataKey="value"
                            stroke="none"
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend verticalAlign="bottom" align="center" iconType="circle" />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AdminStatsChart1;